import {Component} from 'inferno'; // eslint-disable-line @typescript-eslint/no-unused-vars

import {Link} from '../../../common/components';


const assetsUrl = 'https://media.tenor.com/website/gifapi-assets/index.html';


export const AttributionSection = () => {
    return (
        <div id="attribution">
            <h1>Attribution</h1>
            <section className="narrow">
                <h4>
                    All content retrieved from Tenor must be properly
                    attributed by including one of the three following options:
                </h4>
                <ol className="numbered-list indent-align">
                    <li>
                        <b>Powered By Tenor</b> - to be used in the GIF
                        browsing experience
                    </li>
                    <li>
                        <b>Search Tenor</b> - to be used as the placeholder
                        text in the search bar
                    </li>
                    <li>
                        <b>Via Tenor</b> - to be used in the footer of a shared
                        GIF
                    </li>
                </ol>
                <h4>Attribution logos can be found here:</h4>
                <Link to={assetsUrl}>
                    {assetsUrl}</Link>
            </section>
        </div>
    );
};
